import { render, staticRenderFns } from "./TFSCommonForm.vue?vue&type=template&id=246a8e98&scoped=true&"
import script from "./TFSCommonForm.vue?vue&type=script&lang=js&"
export * from "./TFSCommonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a8e98",
  null
  
)

export default component.exports